
export const useGeneratePaginationKey = (apiUrl: string, limit: number) => {

  return (pageIndex: number, previousPageData: number[]) => {
    if (previousPageData && !previousPageData.length) return null;
    return `${apiUrl}page=${pageIndex + 1}&limit=${limit}`;
  };
};